// removed by extract-text-webpack-plugin
module.exports = {"name":"_3IAyg","id":"_1W5MX","status":"if_Fm","code":"xOpKZ","location":"_38mSO"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AdminCentre/components/columns.scss
// module id = 2646
// module chunks = 0